import React from "react"
import type {
  CategoryType,
  Transaction,
  TransactionSummary,
} from "@digits-graphql/frontend/graphql-bearer"
import numberHelper, { CurrencyStyle } from "@digits-shared/helpers/numberHelper"
import { useCumulativeBalance } from "src/frontend/components/Shared/Transactions/Categories/hooks/useCumulativeBalance"

export const BalanceCell: React.FC<{
  transaction: Transaction
  summary: TransactionSummary
  categoryType: CategoryType | undefined
}> = React.memo(({ transaction, categoryType, summary }) => {
  const cumulativeBalance = useCumulativeBalance({ transaction, categoryType, summary })
  if (!cumulativeBalance) {
    return <>N/A</>
  }

  return <>{numberHelper.currency(cumulativeBalance, { style: CurrencyStyle.Detail })}</>
})
